/** @jsx jsx */
import { Link } from 'gatsby'
import { Box, Button, Container, Grid, jsx } from 'theme-ui'
import Chevron from '~/assets/images/icons/chevron.inline.svg'
import Logo from '~/assets/images/logos/maker-wine-logo.inline.svg'

const TunneledNavBar = ({ handleBack, linkLogo }) => {
  return (
    <Box
      as="nav"
      bg="white"
      role="navigation"
      sx={{
        borderBottom: '1px solid',
        borderBottomColor: 'greyLight',
        height: '70px',
        overflow: 'visible',
        position: 'relative',
        zIndex: '1',
      }}
    >
      <Container sx={{ height: '100%' }}>
        <Grid columns={[null, null, null, 12]} sx={{ height: '110%' }}>
          <Box sx={{ gridColumn: [null, null, null, '2 / 12'] }}>
            {handleBack && (
              <Button
                aria-label="Navigate back"
                onClick={handleBack}
                variant="reset"
                sx={{
                  height: '100%',
                  transform: 'translateX(-24px)',
                  width: '64px',
                  '& svg': { height: 'auto', width: '16px' },
                }}
              >
                <Chevron sx={{ transform: 'rotate(90deg) translateX(-5px)' }} />
              </Button>
            )}
            <Box
              sx={{
                left: '50%',
                position: 'absolute',
                top: 'calc(50% + 4px)',
                transform: 'translate(-50%, -50%)',
                '& svg': { height: 'auto', width: '110px' },
              }}
            >
              {linkLogo && (
                <Link to="/">
                  <Logo />
                </Link>
              )}
              {!linkLogo && <Logo />}
            </Box>
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default TunneledNavBar
